import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

import LegacyNotifications from '@bufferapp/notifications';
import AppPages from '~/app-pages';
import { AppModals } from '~/modals';
import { Notifications } from '~/notifications-provider/components/Notifications';
import TemporaryBanner from '~/temporary-banner';
import ThirdParty from '~/thirdParty';
import LoadingGate from '../LoadingGate';

const ThirdPartyWithRouter = withRouter(ThirdParty);
const AppPagesWithRouter = withRouter(AppPages as any);

const appStyle = {
  display: 'flex',
  height: '100%',
};

const contentStyle = {
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column' as const,
  width: '100vw',
  background: '#fff',
  height: '100%',
  overflow: 'hidden',
};

// Can't use stateless function for App since then
// the `DragDropContext` doesn't work.
// eslint-disable-next-line
class App extends Component {
  render() {
    return (
      <div style={appStyle} className="notranslate">
        <div style={contentStyle}>
          <LoadingGate>
            <TemporaryBanner />
            <AppPagesWithRouter />
          </LoadingGate>
        </div>
        <Notifications />
        <LegacyNotifications />
        <AppModals />
        <ThirdPartyWithRouter />
      </div>
    );
  }
}

export default DragDropContext(HTML5Backend)(App);
